var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TheSidebarMenuLayout',_vm._l((_vm.links),function(link){return _c('AppLinkIcon',{key:link.label,class:_vm.borderTopClass(link),attrs:{"link-item":link,"show-label":!_vm.isMobile}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }